import { render, staticRenderFns } from "./ResidentComponent.vue?vue&type=template&id=73bf21cd"
import script from "./ResidentComponent.vue?vue&type=script&lang=js"
export * from "./ResidentComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports